import { render, staticRenderFns } from "./formInventoryBinSelect.vue?vue&type=template&id=883c69fa&"
import script from "./formInventoryBinSelect.vue?vue&type=script&lang=js&"
export * from "./formInventoryBinSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports